module.exports = __webpack_public_path__ + "static/media/star.98555fa4.svg";